import styled from '@appbaseio/vue-emotion';

const InputGroup = styled('div')`
  display: flex;
  align-items: center;
  height: 42px;
  width: 100%;

  .enter-button-wrapper{
    height: 100%;
  }
`;

InputGroup.defaultProps = { className: 'input-group' };

export default InputGroup;
